import { useEffect, useState } from "react";
import { PlaceSuggestionRow, SearchActionRow } from "./search-result-rows";
import {
  getPlaceSuggestionKey,
  getSearchActionKey,
} from "./search-keyboard-navigation";

const DesktopSearchResults = ({
  trimmedSearch,
  visiblePlaceSuggestions,
  topPlace,
  matchedRecentTerms,
  suggestionTerms,
  userLocation,
  isSuggestionLoading,
  onSubmit,
  onPlaceClick,
  desktopNavigationState,
}) => {
  const activeKey = desktopNavigationState?.activeKey || "";
  const setActiveKey = desktopNavigationState?.setActiveKey;
  const isPlaceLookupPending =
    isSuggestionLoading && visiblePlaceSuggestions.length === 0;
  const [isBlockingPlaceLookup, setIsBlockingPlaceLookup] = useState(false);

  useEffect(() => {
    if (!isPlaceLookupPending) {
      setIsBlockingPlaceLookup(false);
      return undefined;
    }

    setIsBlockingPlaceLookup(true);
    const timeout = setTimeout(() => {
      setIsBlockingPlaceLookup(false);
    }, 1200);

    return () => clearTimeout(timeout);
  }, [isPlaceLookupPending, trimmedSearch]);

  const visibleRecentTerms = isBlockingPlaceLookup ? [] : matchedRecentTerms;
  const visibleSuggestionTerms = isBlockingPlaceLookup ? [] : suggestionTerms;
  const shouldShowFallbackAction =
    visiblePlaceSuggestions.length === 0 &&
    visibleRecentTerms.length === 0 &&
    visibleSuggestionTerms.length === 0 &&
    (!isSuggestionLoading || !isBlockingPlaceLookup);

  return (
    <div className="flex flex-col py-2">
      {isPlaceLookupPending && (
        <SearchActionRow
          icon="line-md:loading-twotone-loop"
          label="매장 검색 중..."
          muted
          variant="desktop"
        />
      )}
      {visiblePlaceSuggestions.map((place) => {
        const itemKey = getPlaceSuggestionKey(place);

        return (
          <PlaceSuggestionRow
            key={itemKey}
            place={place}
            userLocation={userLocation}
            showDistance
            variant="desktop"
            useTitleFallback
            isActive={activeKey === itemKey}
            onMouseEnter={() => setActiveKey?.(itemKey)}
            onClick={() => onPlaceClick(place)}
          />
        );
      })}
      {visibleRecentTerms.map((term) => {
        const itemKey = getSearchActionKey("recent", term);

        return (
          <SearchActionRow
            key={itemKey}
            icon="lucide:clock"
            label={term}
            isActive={activeKey === itemKey}
            onMouseEnter={() => setActiveKey?.(itemKey)}
            onClick={() => onSubmit(term)}
            variant="desktop"
          />
        );
      })}
      {visibleSuggestionTerms.map((term) => {
        const itemKey = getSearchActionKey("suggestion", term);

        return (
          <SearchActionRow
            key={itemKey}
            icon="lucide:search"
            label={term}
            isActive={activeKey === itemKey}
            onMouseEnter={() => setActiveKey?.(itemKey)}
            onClick={() => onSubmit(term)}
            variant="desktop"
          />
        );
      })}
      {!topPlace &&
        shouldShowFallbackAction &&
        (() => {
          const itemKey = getSearchActionKey("fallback", trimmedSearch);

          return (
            <SearchActionRow
              icon="lucide:search"
              label={`${trimmedSearch} 검색`}
              isActive={activeKey === itemKey}
              onMouseEnter={() => setActiveKey?.(itemKey)}
              onClick={() => onSubmit(trimmedSearch)}
              variant="desktop"
            />
          );
        })()}
    </div>
  );
};

export default DesktopSearchResults;
